import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { confirmDialog } from "primereact/confirmdialog";
import { DataTable } from "primereact/datatable";
import { Panel } from "primereact/panel";
import { useState } from "react";
import { deleteAnaliseDevolutivaAcao } from "../../../../../../service/Rag/lançamento/acao";
import ModalDevolutivaAcaoSeplag2024 from "./ModalDevolutivaAcaoSeplag2024";

const DevolutivaUnidadeAcaoSetorial2024 = ({
  setAtualizarData,
  ListaAnaliseAcaoDevolutiva,
  dadosItemAcao,
  permissionUser,
  setVisibleModalDevolutiva,
  visibleModaldevolutiva,
  setActionModaDevolutiva,
  actionModalDevolutiva,
  _dataRowOrgaoCentral,
  data,
}) => {
  const [dataRow, setDataRow] = useState([]);
  const actionTemplate = (node) => {
    let buttonEditar;
    let buttonVer;
    let buttonDelete;
    if (permissionUser.edit === true) {
      buttonEditar = (
        <Button
          className="p-button-warning button-margin-left p-button p-component p-button-icon-only"
          style={{ marginRight: ".5em" }}
          onClick={() => {
            editarDevolutiva(node);
          }}
        >
          <i className="pi pi-pencil"></i>
        </Button>
      );
      buttonDelete = (
        <Button
          className="p-button-danger button-margin-left p-button p-component p-button-icon-only"
          onClick={() => {
            confirm(node);
          }}
        >
          <i className="pi pi-trash"></i>
        </Button>
      );
    }
    if (permissionUser.view === true) {
      buttonVer = (
        <Button
          className="p-button-info p-button p-component p-button-icon-only"
          onClick={() => {
            vizualizarDevolutiva(node);
          }}
          style={{ marginRight: ".5em" }}
        >
          <i className="pi pi-search"></i>
        </Button>
      );
    }

    return (
      <div className="formgroup-inline">
        <div className="field-checkbox">
          {buttonEditar}
          {buttonVer}
          {buttonDelete}
        </div>
      </div>
    );
  };
  const respostaSetorialAcaoOptions = [
    { name: "Não acatado", code: 0 },
    { name: "Acatado", code: 1 },
    { name: "Parcialmente acatado", code: 2 },
  ];

  const analiseItemAcaoOptions = [
    { name: "Indicador da Ação", code: 0 },
    { name: "Meta física", code: 1 },
    { name: "Execução Orçamentária", code: 2 },
    { name: "Outros", code: 3 },
  ];
  const confirm = (_data) => {
    confirmDialog({
      message: "Deseja realmente excluir?",
      header: "Confirmação de exclusão",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Sim",
      rejectLabel: "Não",
      accept: () => deleteDevolutiva(_data),
      reject: () => {},
    });
  };

  const vizualizarDevolutiva = (_data) => {
    setDataRow(_data);
    setVisibleModalDevolutiva(true);
    setActionModaDevolutiva({
      edit: false,
      disabled: true,
      create: false,
    });
  };
  const editarDevolutiva = (_data) => {
    setDataRow(_data);
    setVisibleModalDevolutiva(true);
    setActionModaDevolutiva({
      edit: true,
      disabled: false,
      create: false,
    });
  };

  const deleteDevolutiva = async (_data) => {
    await deleteAnaliseDevolutivaAcao(_data.idenAnaliseAcao).then((_res) => {
      window.$toast.current.show({
        severity: "success",
        summary: "Ação Efetuada",
        detail: "Deletado com Sucesso",
        life: 5000,
      });
      setAtualizarData(true);
    });
  };

  const getItem = (code) => {
    const found = analiseItemAcaoOptions.find((item) => item.code == code);
    return found ? found.name : code;
  };

  const getItemSituacao = (code) => {
    const found = respostaSetorialAcaoOptions.find((item) => item.code == code);
    return found ? found.name : code;
  };

  function onPageDataAnalise(event) {}

  return (
    <>
      <Panel header="Devolutiva da equipe da Unidade Setorial">
        <DataTable
          emptyMessage="Nenhum registro encontrado"
          showGridlines
          value={data.ListaAnaliseAcaoDevolutiva}
          dataKey="idenAnaliseAcao"
          paginator={true}
          rows={10}
          size={10}
          totalRecords={12}
          onPage={onPageDataAnalise}
        >
          <Column field="conOrdemAnaliseAcao" header="Ordem" />
          <Column field="numrItemAnaliseAcao" header="Item" body={(rowData) => getItem(rowData.numrItemAnaliseAcao)} />
          <Column
            field="flagAcatadoSetorial"
            header="Situação"
            body={(rowData) => getItemSituacao(rowData.flagAcatadoSetorial)}
          />
          <Column field="descAnaliseAcao" header="Devolutiva" />
          <Column field="dataAnaliseAcao" header="Data" />
          <Column field="nomeAnalistaOrgaoCentral" header="Responsável Setorial" />
          <Column body={actionTemplate} header="Ações" />
        </DataTable>
      </Panel>
      {visibleModaldevolutiva && (
        <ModalDevolutivaAcaoSeplag2024
          visibleModaldevolutiva={visibleModaldevolutiva}
          setVisibleModalDevolutiva={setVisibleModalDevolutiva}
          actionModal={actionModalDevolutiva}
          setActionModal={setActionModaDevolutiva}
          dataRow={dataRow}
          setAtualizarData={setAtualizarData}
          dadosItemAcao={dadosItemAcao}
          _dataRowOrgaoCentral={_dataRowOrgaoCentral}
        />
      )}
    </>
  );
};
export default DevolutivaUnidadeAcaoSetorial2024;
